import React from 'react'
import { TablePagination, Paper } from '@mui/material'
import { useCustomTranslation } from '../../../Hooks/useCustomTranslation'
import TablePaginationActions from './TablePaginationActions'
export interface PaginationProps {
  count: number
  limit: number
  setLimit: (limit: number) => void
  page: number
  setPage: (page: number) => void
  labelRowsPerPage?: string
  className?: string
  elevation?: number
  setCurrPage?: (value: number) => void
  isMobilePaginator?: boolean
  rowsPerPageOptions?: number[]
}

/**
 * Component provides pagination for tables
 */
const Pagination: React.VFC<PaginationProps> = ({
  count,
  limit,
  setLimit,
  page,
  setPage,
  labelRowsPerPage,
  setCurrPage,
  className,
  elevation = 1,
  isMobilePaginator = false,
  rowsPerPageOptions = [3, 5, 10, 25, 50],
}) => {
  const { t } = useCustomTranslation()
  return (
    <TablePagination
      key="Pagination"
      component={Paper}
      count={count}
      rowsPerPage={limit}
      page={page}
      labelRowsPerPage={labelRowsPerPage ?? t('pagination.rowsPerPage')}
      labelDisplayedRows={({ from, to, count }) => {
        return '' + from + '-' + to + ' ' + t('pagination.from') + ' ' + count
      }}
      ActionsComponent={TablePaginationActions}
      backIconButtonProps={{
        'aria-label': 'Nächste Seite',
      }}
      nextIconButtonProps={{
        'aria-label': 'vorherige Seite',
      }}
      onRowsPerPageChange={e => setLimit(parseInt(e.target.value))}
      onPageChange={(_e, page) => {
        setPage(page)
        setCurrPage?.(page)
      }}
      className={className}
      elevation={elevation}
      rowsPerPageOptions={isMobilePaginator ? [10] : rowsPerPageOptions}
    />
  )
}

export default Pagination
